(function(){
  var root = document.querySelector('[data-dpv2][data-dpv2-bundle]');
  if (!root) return;
  var el = root.querySelector('[data-dpv2-bundle-data]');
  var data = {};
  try { data = JSON.parse(el.textContent) || {}; } catch(e){ return; }
  var items = data.items || [], opts = data.opts || [], prices = data.prices || [], extra = data.extra || {};
  var pct = root.getAttribute('data-dpv2-bpct') || '';
  var basePrice = parseInt(root.getAttribute('data-dpv2-bprice'), 10) || 0;
  var isInf = items.some(function(i){ return i.type === 'Infinite options'; });
  function euro(n){ return (Math.round(n * 100) / 100).toFixed(2).replace('.', ',') + ' €'; }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[c]; }); }

  var slots = opts.map(function(o){
    return { name: o.optionName, values: String(o.optionValues || '').split(',').map(function(s){ return s.trim(); }).filter(Boolean) };
  });
  var choice = {};
  slots.forEach(function(s){ if (s.values.length === 1) choice[s.name] = s.values[0]; });

  function priceRow(name){ for (var i=0;i<prices.length;i++){ if (prices[i].option_name === name) return prices[i]; } return null; }
  function lookup(name, val){ var r = priceRow(name); return r && r.option_lookup ? Number(r.option_lookup[val]) : NaN; }
  function minOf(name){ var r = priceRow(name); return r ? Number(r.min_price) : NaN; }
  function kids(name, val){ return items.filter(function(i){ return (i.variant_options || []).some(function(r){ return r.name === name && String(r.value) === String(val); }); }); }
  function complete(){ return slots.every(function(s){ return !!choice[s.name]; }); }
  function label(c){
    var t = c.product_title || '', vt = c.variant_title || '';
    if (vt && vt !== 'Default Title' && t.indexOf(vt) < 0) t += ' · ' + vt;
    var q = c.quantity_in_bundle || 1;
    return (q > 1 ? q + '× ' : '') + t;
  }
  function placeholder(s){
    var k = items.filter(function(i){ return (i.variant_options || []).some(function(r){ return r.name === s.name; }); });
    var titles = k.map(function(i){ return i.product_title; }).filter(function(t, i, a){ return a.indexOf(t) === i; });
    if (titles.length === 1) return titles[0] + ', Sorte nach Wahl';
    return s.name.split('/')[0].replace(/-?Geschmack/i, '').trim() + ' nach Wahl';
  }
  function dietFor(list){
    var d = list.map(function(c){ return (extra[String(c.variant_id)] || {}).diet || ''; });
    var u = d.filter(function(x, i, a){ return a.indexOf(x) === i; });
    return u.length === 1 && u[0] ? (u[0] === 'vegan' ? 'Vegan' : (u[0] === 'vegetarisch' ? 'Vegetarisch' : '')) : '';
  }
  function childSum(list){ return list.reduce(function(s, c){ return s + Number(c.price || 0) * (c.quantity_in_bundle || 1); }, 0); }

  /* Das ist drin: feste Produkte zuerst, dann die Wahl-Felder in Menue-Reihenfolge */
  var listEl = root.querySelector('[data-dpv2-binh]');
  function renderList(){
    if (!listEl || !items.length) return;
    var html = [];
    if (!isInf){ items.forEach(function(c){ html.push('<li>' + esc(label(c)) + '</li>'); }); }
    else {
      slots.filter(function(s){ return s.values.length === 1; }).forEach(function(s){ kids(s.name, s.values[0]).forEach(function(c){ html.push('<li>' + esc(label(c)) + '</li>'); }); });
      slots.filter(function(s){ return s.values.length > 1; }).forEach(function(s){
        if (choice[s.name]) kids(s.name, choice[s.name]).forEach(function(c){ html.push('<li class="is-chosen">' + esc(label(c)) + '</li>'); });
        else html.push('<li class="is-open">' + esc(placeholder(s)) + '</li>');
      });
    }
    listEl.innerHTML = html.join('');
  }

  /* Auswahlmenues je Wahl-Feld */
  var wrap = root.querySelector('[data-dpv2-bslots]');
  var ui = [];
  function buildSlots(){
    if (!wrap) return;
    slots.forEach(function(s, si){
      if (s.values.length < 2) return;
      var box = document.createElement('div');
      box.className = 'dpv2-select';
      var lid = 'Dpv2BL' + si;
      box.innerHTML = '<span class="dpv2-select-label" id="' + lid + '">' + esc(s.name) + '</span>' +
        '<button type="button" class="dpv2-select-btn" aria-haspopup="listbox" aria-expanded="false" aria-labelledby="' + lid + ' ' + lid + 'v"><span class="dpv2-select-thumb"></span><span class="dpv2-select-text" id="' + lid + 'v">Bitte auswählen</span><svg class="dpv2-select-chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg></button>' +
        '<ul class="dpv2-select-list" role="listbox" tabindex="-1" aria-labelledby="' + lid + '" hidden></ul>';
      var list = box.querySelector('ul');
      var showDiet = !/shaker|flasche|zubeh/i.test(s.name);
      s.values.forEach(function(val, vi){
        var k = kids(s.name, val);
        var img = k.length ? (extra[String(k[0].variant_id)] || {}).img : '';
        var diet = showDiet ? dietFor(k) : '';
        var li = document.createElement('li');
        li.className = 'dpv2-opt';
        li.id = lid + 'o' + vi;
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');
        li.setAttribute('data-val', val);
        li.innerHTML = '<span class="dpv2-opt-thumb">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="dpv2-opt-name">' + esc(val) + '</span><span class="dpv2-opt-price" data-delta></span>' +
          (diet ? '<span class="dpv2-opt-diet">' + diet + '</span>' : '');
        list.appendChild(li);
      });
      var host = document.createElement('div');
      host.className = 'dpv2-bslot';
      host.appendChild(box);
      wrap.appendChild(host);
      ui.push({ slot: s, box: box, btn: box.querySelector('button'), list: list });
    });
    ui.forEach(function(u){
      var opts = Array.prototype.slice.call(u.list.children);
      var active = -1;
      function setActive(i){ opts.forEach(function(o, k){ o.classList.toggle('is-active', k === i); }); active = i; if (opts[i]){ u.list.setAttribute('aria-activedescendant', opts[i].id); opts[i].scrollIntoView({ block: 'nearest' }); } }
      function open(){ ui.forEach(function(x){ if (x !== u) close(x, false); }); u.list.hidden = false; u.btn.setAttribute('aria-expanded', 'true'); var i = 0; opts.forEach(function(o, k){ if (o.getAttribute('aria-selected') === 'true') i = k; }); setActive(i); u.list.focus(); }
      function pick(o){ choice[u.slot.name] = o.getAttribute('data-val'); close(u, true); update(); }
      u.btn.addEventListener('click', function(){ if (u.list.hidden) open(); else close(u, false); });
      u.btn.addEventListener('keydown', function(e){ if (e.key === 'ArrowDown' || e.key === 'ArrowUp'){ e.preventDefault(); open(); } });
      opts.forEach(function(o, k){ o.addEventListener('click', function(){ pick(o); }); o.addEventListener('mousemove', function(){ if (active !== k) setActive(k); }); });
      u.list.addEventListener('keydown', function(e){
        if (e.key === 'ArrowDown'){ e.preventDefault(); setActive(Math.min(opts.length - 1, active + 1)); }
        else if (e.key === 'ArrowUp'){ e.preventDefault(); setActive(Math.max(0, active - 1)); }
        else if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); if (opts[active]) pick(opts[active]); }
        else if (e.key === 'Escape' || e.key === 'Tab'){ close(u, e.key === 'Escape'); }
      });
    });
    document.addEventListener('click', function(e){ ui.forEach(function(u){ if (!u.list.hidden && !u.box.contains(e.target)) close(u, false); }); });
  }
  function close(u, focus){ u.list.hidden = true; u.btn.setAttribute('aria-expanded', 'false'); if (focus) u.btn.focus(); }

  /* Aufpreise relativ zur aktuellen Auswahl (sonst zum guenstigsten) */
  function renderSlots(){
    ui.forEach(function(u){
      var sel = choice[u.slot.name];
      var base = sel ? lookup(u.slot.name, sel) : minOf(u.slot.name);
      Array.prototype.forEach.call(u.list.children, function(o){
        var val = o.getAttribute('data-val');
        var on = val === sel;
        o.setAttribute('aria-selected', on ? 'true' : 'false');
        var d = lookup(u.slot.name, val) - base;
        o.querySelector('[data-delta]').textContent = on ? 'ausgewählt' : (isNaN(d) || Math.abs(d) < 0.005 ? '' : (d > 0 ? '+' : '−') + euro(Math.abs(d)));
        if (on){
          u.btn.querySelector('.dpv2-select-text').textContent = val;
          var img = o.querySelector('.dpv2-opt-thumb img');
          u.btn.querySelector('.dpv2-select-thumb').innerHTML = img ? '<img src="' + img.getAttribute('src') + '" alt="">' : '';
        }
      });
      if (!sel){ u.btn.querySelector('.dpv2-select-text').textContent = 'Bitte auswählen'; u.btn.querySelector('.dpv2-select-thumb').innerHTML = ''; }
    });
  }

  /* Preis, Ersparnis, Button */
  var priceEl = root.querySelector('[data-dpv2-price]');
  var saveEl = root.querySelector('[data-dpv2-bsave]');
  function applyPrice(){
    var bundle, regular, from = false;
    if (isInf){
      if (complete()){
        bundle = slots.reduce(function(s, x){ return s + lookup(x.name, choice[x.name]); }, 0);
        regular = slots.reduce(function(s, x){ return s + childSum(kids(x.name, choice[x.name])); }, 0);
      } else {
        from = true;
        bundle = basePrice / 100;
        regular = slots.reduce(function(s, x){
          var sums = x.values.map(function(v){ return childSum(kids(x.name, v)); });
          return s + Math.min.apply(null, sums);
        }, 0);
      }
    } else {
      bundle = basePrice / 100;
      regular = childSum(items);
    }
    if (priceEl && !isNaN(bundle)) priceEl.textContent = (from ? 'ab ' : '') + euro(bundle);
    if (saveEl){
      var saving = regular - bundle;
      if (regular > 0 && saving > 0.004){
        saveEl.querySelector('[data-dpv2-bsum]').textContent = (from ? 'ab ' : '') + euro(regular);
        saveEl.querySelector('[data-dpv2-bsaving]').textContent = (from ? 'ab ' : '') + euro(saving);
        saveEl.hidden = false;
      } else { saveEl.hidden = true; }
    }
    var atc = root.querySelector('[data-dpv2-atc]');
    if (isInf && !complete()){
      root.setAttribute('data-dpv2-block', '1');
      if (atc){ atc.disabled = true; atc.textContent = 'Bitte auswählen'; }
    } else {
      root.removeAttribute('data-dpv2-block');
      if (atc && atc.textContent === 'Bitte auswählen'){ atc.disabled = false; atc.textContent = 'In den Warenkorb'; }
    }
  }

  /* Lagerbestand: kleinste Menge der enthaltenen (gewaehlten) Produkte */
  function chosenKids(){
    if (!isInf) return items;
    var out = [];
    slots.forEach(function(x){ if (choice[x.name]) out = out.concat(kids(x.name, choice[x.name])); });
    return out;
  }
  function applyStock(){
    var row = root.querySelector('[data-dpv2-stockrow]');
    var stock = root.querySelector('[data-dpv2-stock]');
    var dot = root.querySelector('[data-dpv2-dot]');
    var qty = root.querySelector('[data-dpv2-qty]');
    var atc = root.querySelector('[data-dpv2-atc]');
    if (!row || !stock || !dot) return;
    if (isInf && !complete()){ row.hidden = true; return; }
    row.hidden = false;
    var cap = null, out = false;
    chosenKids().forEach(function(c){
      var x = extra[String(c.variant_id)] || {};
      if (x.a === false) out = true;
      if (x.m){ var n = Math.floor((x.q || 0) / (c.quantity_in_bundle || 1)); if (cap === null || n < cap) cap = n; }
    });
    dot.className = 'dpv2-dot';
    if (out || cap === 0){
      stock.textContent = 'Derzeit nicht verfügbar'; dot.classList.add('dpv2-dot--out');
      if (atc){ atc.disabled = true; atc.textContent = 'Ausverkauft'; }
      return;
    }
    if (cap === null){ stock.textContent = 'Sofort lieferbar'; dot.classList.add('dpv2-dot--ok'); return; }
    stock.textContent = cap <= 5 ? 'Nur noch ' + cap + ' Stück auf Lager' : cap + ' Stück auf Lager';
    dot.classList.add(cap <= 5 ? 'dpv2-dot--low' : 'dpv2-dot--ok');
    if (qty){ qty.setAttribute('max', cap); if ((parseInt(qty.value, 10) || 1) > cap) qty.value = cap; }
  }

  /* Angaben je enthaltenem Produkt: nur feste und gewaehlte zeigen */
  function applyParts(){
    var ids = chosenKids().map(function(c){ return String(c.variant_id); });
    root.querySelectorAll('[data-dpv2-bpart]').forEach(function(p){ p.hidden = ids.indexOf(p.getAttribute('data-dpv2-bpart')) < 0; });
    var hint = root.querySelector('[data-dpv2-bparts-hint]');
    if (hint) hint.hidden = !(isInf && !complete());
  }

  /* App-Auswahlfelder im Hintergrund mitziehen (sie liefern die Warenkorb-Eigenschaften) */
  var form = root.querySelector('[data-dpv2-form]');
  function syncNative(){
    if (!form) return;
    form.querySelectorAll('#simple-bundles-io-options select[name^="properties["]').forEach(function(s){
      var name = s.name.slice('properties['.length, -1);
      var val = choice[name];
      if (!val || s.value === val) return;
      var ok = Array.prototype.some.call(s.options, function(o){ return o.value === val; });
      if (!ok) return;
      s.value = val;
      s.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  if (form){
    new MutationObserver(function(muts){
      var hit = muts.some(function(m){ var t = m.target.nodeType === 1 ? m.target : m.target.parentElement; return t && t.closest && (t.closest('#simple-bundles-io-options') || (t.querySelector && t.querySelector('#simple-bundles-io-options'))); });
      if (hit) syncNative();
    }).observe(form, { childList: true, subtree: true });
  }

  function update(){ renderList(); renderSlots(); applyPrice(); applyStock(); applyParts(); syncNative(); }
  root.addEventListener('dpv2:rendered', function(){ applyPrice(); applyStock(); });
  buildSlots();
  update();
})();
